module.exports = __webpack_public_path__ + "img/11.a542e260.png";